// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.home {
  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
}

.toast-root .MuiAlert-filledSuccess {
  min-width: 65%;
  /* width: 100%; */
  color: var(--default-FontColour);
  box-shadow: none;
  background-color: white;
  border: 1px solid #1f3c88;
  color: #1f3c88;
  font-weight: var(--header-FontWeight);
}

#Mui_Alert {
  min-width: auto;
  margin-right: 1%;
  background-color: white;
  border-radius: 5px;
}

.toast-root .MuiAlert-filledInfo {
  /* width: 100%; */
  min-width: 65%;
  /* background-color: rgb(232, 244, 253); */
  /* background-color: rgb(229, 246, 253); */
  background-color: #4ca6d6;
  box-shadow: none;
}

.toast-root .MuiAlert-filledError .MuiAlert-icon {
  color: var(--errorToastColor);
}

.toast-root .MuiAlert-outlinedError .MuiAlert-icon {
  color: var(--errorToastColor);
}

.toast-root .MuiAlert-filledSuccess .MuiAlert-icon {
  color: var(--successToastColor);
}

.toast-root .MuiAlert-outlinedSuccess .MuiAlert-icon {
  color: var(--successToastColor);
}

.toast-root .MuiAlert-filledError,
.toast-root .MuiAlert-outlinedError {
  width: 100%;
  min-width: 65%;
  background-color: white;
  border: 1px solid var(--errorToastColor);
  color: var(--errorToastColor);
  box-shadow: none;
  max-height: 90vh;
  overflow: auto;
  font-weight: var(--header-FontWeight);
}

.toast-root .MuiAlert-filledSuccess,
.toast-root .MuiAlert-outlinedSuccess {
  width: 100%;
  min-width: 65%;
  background-color: white;
  border: 1px solid var(--successToastColor);
  color: var(--successToastColor);
  box-shadow: none;
  max-height: 90vh;
  overflow: auto;
  font-weight: var(--header-FontWeight);
}

.MuiAlert-action {
  color: #000;
}

.MuiSnackbar-root.MuiSnackbar-anchorOriginBottomCenter.toast-root {
  bottom: auto;
  width: 75%;
  /* min-width: 65%; */
  z-index: 2001;
  /* position: relative;
   bottom: 0;
   display: flex;
   z-index: 0;
   justify-content: flex-start; */
}

.toast-root .MuiAlert-filledSuccess .MuiAlert-icon {
  color: #1f3c88;
}

#Mui_Alert .MuiPaper-root.MuiAlert-root {
  padding: 2px 8px;
}

#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-icon .MuiSvgIcon-root {
  font-size: smaller;
}

#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-icon {
  padding: 6px 0;
  margin-right: 5px;
}

#Mui_Alert {
  top: 5px;
  z-index: 2010;
}

#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-message {
  padding: 5px 0;
}

.MuiPaper-root.MuiPaper-elevation
  .MuiAlert-action
  .MuiButtonBase-root.MuiIconButton-sizeSmall {
  padding: 1px 3px 2px 0;
  font-weight: var(--header-FontWeight);
}

.MuiPaper-root.MuiPaper-elevation
  .MuiAlert-action
  .MuiButtonBase-root.MuiIconButton-sizeSmall:hover {
  background-color: unset;
  /* transform: scale(1.1); */
}

.MuiPaper-root.MuiPaper-elevation.alert.error
  .MuiAlert-action
  .MuiButtonBase-root.MuiIconButton-sizeSmall {
  color: var(--errorToastColor);
}

.MuiPaper-root.MuiPaper-elevation.alert.success
  .MuiAlert-action
  .MuiButtonBase-root.MuiIconButton-sizeSmall {
  color: var(--successToastColor);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/toast/Toast.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb;;;;iCAI+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,+BAA+B;AACjC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.home {\n  transition: all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;\n}\n\n.toast-root .MuiAlert-filledSuccess {\n  min-width: 65%;\n  /* width: 100%; */\n  color: var(--default-FontColour);\n  box-shadow: none;\n  background-color: white;\n  border: 1px solid #1f3c88;\n  color: #1f3c88;\n  font-weight: var(--header-FontWeight);\n}\n\n#Mui_Alert {\n  min-width: auto;\n  margin-right: 1%;\n  background-color: white;\n  border-radius: 5px;\n}\n\n.toast-root .MuiAlert-filledInfo {\n  /* width: 100%; */\n  min-width: 65%;\n  /* background-color: rgb(232, 244, 253); */\n  /* background-color: rgb(229, 246, 253); */\n  background-color: #4ca6d6;\n  box-shadow: none;\n}\n\n.toast-root .MuiAlert-filledError .MuiAlert-icon {\n  color: var(--errorToastColor);\n}\n\n.toast-root .MuiAlert-outlinedError .MuiAlert-icon {\n  color: var(--errorToastColor);\n}\n\n.toast-root .MuiAlert-filledSuccess .MuiAlert-icon {\n  color: var(--successToastColor);\n}\n\n.toast-root .MuiAlert-outlinedSuccess .MuiAlert-icon {\n  color: var(--successToastColor);\n}\n\n.toast-root .MuiAlert-filledError,\n.toast-root .MuiAlert-outlinedError {\n  width: 100%;\n  min-width: 65%;\n  background-color: white;\n  border: 1px solid var(--errorToastColor);\n  color: var(--errorToastColor);\n  box-shadow: none;\n  max-height: 90vh;\n  overflow: auto;\n  font-weight: var(--header-FontWeight);\n}\n\n.toast-root .MuiAlert-filledSuccess,\n.toast-root .MuiAlert-outlinedSuccess {\n  width: 100%;\n  min-width: 65%;\n  background-color: white;\n  border: 1px solid var(--successToastColor);\n  color: var(--successToastColor);\n  box-shadow: none;\n  max-height: 90vh;\n  overflow: auto;\n  font-weight: var(--header-FontWeight);\n}\n\n.MuiAlert-action {\n  color: #000;\n}\n\n.MuiSnackbar-root.MuiSnackbar-anchorOriginBottomCenter.toast-root {\n  bottom: auto;\n  width: 75%;\n  /* min-width: 65%; */\n  z-index: 2001;\n  /* position: relative;\n   bottom: 0;\n   display: flex;\n   z-index: 0;\n   justify-content: flex-start; */\n}\n\n.toast-root .MuiAlert-filledSuccess .MuiAlert-icon {\n  color: #1f3c88;\n}\n\n#Mui_Alert .MuiPaper-root.MuiAlert-root {\n  padding: 2px 8px;\n}\n\n#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-icon .MuiSvgIcon-root {\n  font-size: smaller;\n}\n\n#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-icon {\n  padding: 6px 0;\n  margin-right: 5px;\n}\n\n#Mui_Alert {\n  top: 5px;\n  z-index: 2010;\n}\n\n#Mui_Alert .MuiPaper-root.MuiAlert-root .MuiAlert-message {\n  padding: 5px 0;\n}\n\n.MuiPaper-root.MuiPaper-elevation\n  .MuiAlert-action\n  .MuiButtonBase-root.MuiIconButton-sizeSmall {\n  padding: 1px 3px 2px 0;\n  font-weight: var(--header-FontWeight);\n}\n\n.MuiPaper-root.MuiPaper-elevation\n  .MuiAlert-action\n  .MuiButtonBase-root.MuiIconButton-sizeSmall:hover {\n  background-color: unset;\n  /* transform: scale(1.1); */\n}\n\n.MuiPaper-root.MuiPaper-elevation.alert.error\n  .MuiAlert-action\n  .MuiButtonBase-root.MuiIconButton-sizeSmall {\n  color: var(--errorToastColor);\n}\n\n.MuiPaper-root.MuiPaper-elevation.alert.success\n  .MuiAlert-action\n  .MuiButtonBase-root.MuiIconButton-sizeSmall {\n  color: var(--successToastColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
